module.exports = __webpack_public_path__ + "static/motorik-216ba3f3484544dd625d7ee0192aa4a1.jpg";